<template>
    <section class="hero is-warning is-fullheight">
      <div class="hero-body">
        <div class="container">
          <div class="content is-large">
            <article class="media">
              <figure class="media-left">
                <p class="image is-128x128">
                  <img class="is-rounded" src="https://bulma.io/images/placeholders/128x128.png">
                </p>
              </figure>
              <div class="media-content">
                <div class="content">
                  <div>
                    <strong>Christoph Noe</strong> <small>@neonnoe</small>
                    <br>
                    <div class="box">
                    Thank's for your interest. Please let me know, if I could help you.
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>

          <!-- <div class="field is-grouped">
            <div class="control">
              <button class="button is-link">Submit</button>
            </div>
            <div class="control">
              <button class="button is-text">Cancel</button>
            </div>
          </div> -->
        </div>
      </div>
    </section>

</template>

<script>
export default {
  name: 'Contact',
  props: {
  },
};
</script>
